import { DynamicPackagesFormStepNames, FormStep } from '../types';

/**
 * Drops the separate spa selection step and carries its options onto the
 * experience step.
 *
 * ecom1 asks which options the guest wants on one page and their times on the
 * next. The ecom2 page asks both together, so the selection step would
 * otherwise be shown twice over.
 */
export const foldSelectionIntoExperienceStep = (steps: FormStep[]): FormStep[] => {
  const selectStep = steps.find(
    ({ step }) => step === DynamicPackagesFormStepNames.SELECT_SPA_EXPERIENCE
  );

  if (!selectStep) return steps;

  return steps
    .filter(({ step }) => step !== DynamicPackagesFormStepNames.SELECT_SPA_EXPERIENCE)
    .map((step) =>
      step.step === DynamicPackagesFormStepNames.EXPERIENCE
        ? {
            ...step,
            selectExperienceOptions: selectStep.selectExperienceOptions,
            selectExperienceOptionsByDayNumber: selectStep.selectExperienceOptionsByDayNumber,
          }
        : step
    );
};
